import { Field, TextOutput } from 'Components/Core';
import { ListFieldSection } from 'Components/Layout';
import { WorksheetsResultsMessagesSection } from 'Components/Worksheets/Core';
import { IWorksheetComponent } from 'Components/Worksheets/Core/types';
import React from 'react';
import { withInjectedProps } from '../../../../Core/InjectedPropsContext';

const Section: React.FC<IWorksheetComponent> = ({ createWorksheetSelector }) => {
  return (
    <>
      <WorksheetsResultsMessagesSection />
      <ListFieldSection>
        <Field input={<TextOutput />} name="Results.InsituWetDensity" />
        <Field input={<TextOutput />} name="Results.InsituMoistureContent" />
        <Field input={<TextOutput />} name="Results.InsituDryDensity" />
      </ListFieldSection>
    </>
  );
};

const AsResultsSection = withInjectedProps(Section);

export { AsResultsSection };
export default AsResultsSection;
